import type { ButtonSize, ButtonTone } from './types';
import { TONE_GRADIENTS } from './constants';

export const classes = {
  base: 'relative inline-flex cursor-pointer items-center justify-center gap-[7px] rounded-[11px] font-sans transition-[filter,background-color,color,border-color] duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-accent/40 dark:focus-visible:ring-brand-accent-dark/50 disabled:pointer-events-none',
  content: 'relative z-[1] inline-flex items-center justify-center gap-[7px]',
  md: 'px-4 py-[9px] text-[13px]',
  sm: 'px-[13px] py-[7px] text-[12px]',
  primary:
    'overflow-hidden border-none bg-grey-2 font-bold text-white hover:brightness-[1.12] hover:saturate-[1.05] disabled:text-taupe-1 dark:bg-white/[0.06] dark:disabled:text-mauve-3',
  secondary:
    'border border-solid border-black/10 bg-white/[0.82] font-semibold text-taupe-3 hover:bg-grey-2 disabled:text-taupe-1 dark:border-white/[0.12] dark:bg-[#332e43]/[0.84] dark:text-mauve-1 dark:hover:bg-white/[0.1] dark:disabled:text-mauve-3',
  ghost:
    'border-none bg-transparent font-semibold text-taupe-2 hover:bg-black/[0.06] hover:text-taupe-3 disabled:text-taupe-1 dark:text-mauve-2 dark:hover:bg-white/[0.06] dark:hover:text-mauve-1 dark:disabled:text-mauve-3',
  gradientLayer:
    'pointer-events-none absolute inset-0 z-0 rounded-[inherit] transition-opacity duration-150',
  gradientHidden: 'opacity-0',
  spinner:
    'inline-block shrink-0 animate-spin rounded-full border-2 border-current border-t-transparent',
  spinnerMd: 'size-[15px]',
  spinnerSm: 'size-[13px]',
};

export function getToneGradient(tone: ButtonTone) {
  return TONE_GRADIENTS[tone];
}

export function getSpinnerSize(size: ButtonSize) {
  return size === 'sm' ? classes.spinnerSm : classes.spinnerMd;
}
